import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { MainService } from "../../../services/main/main.service";
import { AuthService } from "../../../services/auth/auth.service";
import * as REGEX from '../../../shared/regex';
import { getUserProfile, getUserProfiles, setUserProfiles } from 'src/app/core/session';

@Component({
  selector: "app-business",
  templateUrl: "./business.component.html",
  styleUrls: ["./business.component.scss"],
  encapsulation: ViewEncapsulation.None
})
export class BusinessComponent implements OnInit {
  public mask = REGEX.mobile_mask;
  public zip_mask = REGEX.zip_mask;
  is_submitting: boolean = false;
  business_details: UntypedFormGroup;
  constructor(
    private fb: UntypedFormBuilder,
    private mainService: MainService,
    private authService: AuthService,
  ) { }

  zip: any;
  profile: any;
  ngOnInit() {
    this.profile = localStorage.getItem("userProfileData") && getUserProfiles() && getUserProfile();
    this.initForm();
    this.patchValue();
  }


  initForm() {
    this.business_details = this.fb.group({
      practice_name: [{ value:  this.profile.practice_name || '', disabled: true }, [Validators.required, Validators.minLength(2), Validators.pattern(/^[A-Za-z0-9' ]+$/)]],
      practice_email: ["", [Validators.required, Validators.pattern(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]],
      practice_mobile: ["", [Validators.required, Validators.pattern(new RegExp("[0-9 ]{10}"))]],
      practice_address: ["", Validators.required],
      state: [{ value: "", disabled: true }],
      zipCode: ["", [Validators.required]],
      city: [{ value: "", disabled: true }],
      city_id: [""],
      state_id: [""],
      doctor_email: ""
    });
    this.patchValue();
  }

  patchValue() {
    try {
      let value = {
        practice_name: this.profile.practice_name,
        practice_email: this.profile.practice_email,
        practice_mobile: this.profile.practice_mobile && this.profile.practice_mobile !== "" && this.profile.practice_mobile.split("-")[1],
        practice_address: this.profile.practice_address,
        state: this.profile.state_name,
        zipCode: this.profile.zip,
        city: this.profile.city,
        city_id: this.profile.city_id,
        state_id: this.profile.state_id,
        title: this.profile.title,
        doctor_email: this.profile.doctor_email,
        State: this.profile.state_name,
        ind_id: this.profile.ind_id,
        doctor_speciality: this.profile.doctor_speciality,
      };
      this.business_details.patchValue(value);
      if (this.profile.practice_address) {
        this.business_details.controls.practice_address.disable();
      }
      if (this.profile.zip) {
        this.business_details.controls.zipCode.disable();
      }
      this.zip = this.profile.zip;
    } catch (error) {
      console.log(error);
    }
  }

  submitdata() {
    if (this.business_details.invalid) {
      this.is_submitting = true;
      return
    }
    else {
      if (this.business_details.value.practice_mobile == '0000000000') {
        return false;
      }
      else {
        let formdata = new FormData();
        let token = localStorage.getItem("token");
        formdata.append("access_token", token);
        let values = this.business_details.value;
        Object.keys(values).forEach((keys)=>{
          formdata.append(keys, values[keys] ? String(values[keys]) : '');
        })
        formdata.delete('practice_mobile')
        formdata.delete('state_id')
        formdata.append('practice_mobile', '+1-' + values.practice_mobile.toString().replace(/[{()}-]/g))
        this.mainService
          .uploadApi(formdata, "edit_business_profile", false)
          .subscribe((data: any) => {
            if (data && data.is_error == 0) {
              this.mainService.customPopups('Business information updated successfully.', 0)
              this.profile = { ...this.profile, ...data.profile[0] }
              let data_1 = [{ ...this.profile, ...data.profile[0] }]
              setUserProfiles(data_1)
              this.authService.userProfileData$.next([{ ...this.profile, ...data.profile[0] }])
              this.getOtherProfile();
              return
            }
            if (data.is_error !== 0 && data && data.err && data.err.indexOf("date_of_birth") >= 0) {
              this.mainService.customPopups("Date Of birth is not a valid date.", 1)
              return
            }
          });
      }
    }
  }

  cahangeFormzip(event) {
    try {

      if (event == '') {
        this.business_details.controls.zipCode.setValue('')
        this.business_details.controls.zipCode.markAsTouched()
        this.business_details.controls.state.setValue('')
        this.business_details.controls.state.markAsTouched()
        this.business_details.controls.city.setValue('')
        this.business_details.controls.city.markAsTouched()
      }
      else {
        this.business_details.controls.zipCode.setValue(event.zip)
        this.business_details.controls.zipCode.markAsDirty()
        this.business_details.controls.city.setValue(event.city)
        this.business_details.controls.state.setValue(event.state_name)
        this.business_details.controls.city_id.setValue(event.city_id)
        this.business_details.controls.zipCode.markAsTouched()
        this.business_details.controls.state.markAsTouched()
        this.business_details.controls.city.markAsTouched()
        this.business_details.markAsDirty()
      }
    } catch (error) {
      console.log(error);

    }
  }

  async getOtherProfile() {
    try {
      this.business_details.markAsPristine()
    } catch (error) {
      console.log(error)
    }
  }

}
